import { Picker } from "@certn/cascadia-react";
import { useTranslation } from "react-i18next";

import { useQueryParams } from "../../../hooks/useQueryParams";

export function TagFilter() {
  const { setParam, params } = useQueryParams();
  const { t } = useTranslation();

  const tagItems = [
    { key: "true", label: t("Active") },
    { key: "false", label: t("Inactive") },
  ];

  return (
    <Picker
      label={t("Status")}
      showActionBar
      selectionMode="single"
      selectedKeys={params.is_active?.split(",") || []}
      onSelectionChange={(keys) => setParam("is_active", Array.from(keys))}
      items={tagItems?.map((option: { key: string; label: string }) => ({
        id: option.key,
        name: option.label,
      }))}
      testID="tag-status-filter-picker"
    />
  );
}
